import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

const Badge = ({ 
  children, 
  variant = 'default',
  size = 'md',
  status = false,
  className = '' 
}) => {
  const { theme } = useTheme();

  const variantColorMap = {
    default: theme.colors.secondary,
    primary: theme.colors.primary,
    success: theme.colors.success,
    warning: theme.colors.warning,
    danger: theme.colors.error,
    info: '#3b82f6',
  };

  const variants = {
    default: {
      backgroundColor: theme.colors.backgroundSecondary,
      color: theme.colors.text,
      border: `1px solid ${theme.colors.border}`,
    },
    primary: {
      backgroundColor: `${theme.colors.primary}15`,
      color: theme.colors.primary,
      border: `1px solid ${theme.colors.primary}30`,
    },
    success: {
      backgroundColor: `${theme.colors.success}15`,
      color: theme.colors.success,
      border: `1px solid ${theme.colors.success}30`,
    },
    warning: {
      backgroundColor: `${theme.colors.warning}15`,
      color: theme.colors.warning,
      border: `1px solid ${theme.colors.warning}30`,
    },
    danger: {
      backgroundColor: `${theme.colors.error}15`,
      color: theme.colors.error,
      border: `1px solid ${theme.colors.error}30`,
    },
    info: {
      backgroundColor: '#3b82f615',
      color: '#3b82f6',
      border: '1px solid #3b82f630',
    },
  };

  const sizes = {
    sm: {
      padding: '2px 8px',
      fontSize: '11px',
      fontWeight: '500',
    },
    md: {
      padding: '4px 10px',
      fontSize: '12px',
      fontWeight: '600',
    },
    lg: {
      padding: '6px 12px',
      fontSize: '13px',
      fontWeight: '600',
    },
  };

  const styles = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    borderRadius: status ? '20px' : '6px',
    textTransform: status ? 'none' : 'uppercase',
    letterSpacing: status ? '0.02em' : '0.5px',
    whiteSpace: 'nowrap',
    ...variants[variant],
    ...sizes[size],
    ...(status
      ? {
          backgroundColor: variantColorMap[variant] || theme.colors.secondary,
          color: '#ffffff',
          border: 'none',
          padding: '6px 16px',
          fontSize: '10px',
          fontWeight: '700',
        }
      : {}),
  };

  return (
    <span style={styles} className={className}>
      {children}
    </span>
  );
};

export default Badge;
